import theTime from "$lib/utils/the-time";

export { theTime };

/** getHoursOfUTCDateTimeStringFromDateDay
 * @return string[] - all hours of local day in UTC date time string
 */
export const getHoursOfUTCDateTimeStringFromDateDay = (forDate = new Date()) => {
  const dateHHInit = new Date(forDate.getFullYear(), forDate.getMonth(), forDate.getDate());
  // Recursively get all hours from Date
  const getAllHours = (d: Date, acc: string[] = []): string[] => {
    const next = new Date(d);
    next.setUTCHours(next.getUTCHours() + 1);
    acc.push(d.toISOString());
    return next.getDate() === d.getDate() ? getAllHours(next, acc) : acc;
  };

  return getAllHours(dateHHInit);
};

export default theTime;
